import { useEffect, useState } from 'react'
import { fetchPortfolioGroups } from '../../api/portfolio'
import type { PortfolioGroup } from './types'

export function PortfolioGroups() {
  const [items, setItems] = useState<PortfolioGroup[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await fetchPortfolioGroups()
      setItems(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load groups')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  if (loading) {
    return <div className="text-swiss-small text-swiss-gray-500">Loading groups...</div>
  }

  if (error) {
    return (
      <div className="border border-swiss-red bg-swiss-off-white p-4">
        <p className="text-swiss-small text-swiss-red mb-2">{error}</p>
        <button onClick={load} className="text-swiss-small underline underline-offset-2 cursor-pointer">
          Retry
        </button>
      </div>
    )
  }

  if (items.length === 0) {
    return (
      <div className="border border-swiss-gray-200 bg-swiss-off-white p-6">
        <h2 className="text-swiss-label uppercase tracking-widest text-swiss-gray-500 mb-3">
          Groups & Broadcasts
        </h2>
        <p className="text-swiss-small text-swiss-gray-500">No connected groups found on dispatch network.</p>
      </div>
    )
  }

  return (
    <div className="border border-swiss-gray-200 bg-swiss-off-white p-4">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-swiss-label uppercase tracking-widest text-swiss-gray-500">
          Groups & Broadcasts
        </h2>
        <button onClick={load} className="text-swiss-caption text-swiss-gray-500 underline underline-offset-2 cursor-pointer">
          Refresh
        </button>
      </div>
      <div className="space-y-2">
        {items.map((group) => (
          <div key={group.id} className="border border-swiss-gray-200 bg-swiss-white p-3">
            <div className="flex items-center justify-between gap-3">
              <p className="text-swiss-small text-swiss-black">{group.name}</p>
              <span className="text-swiss-caption font-swiss-mono text-swiss-gray-400">
                {group.memberCount || 0} members
              </span>
            </div>
            {group.description && (
              <p className="text-swiss-small text-swiss-gray-700 mt-2">{group.description}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
